
// Mock data for development purposes
export const recebimentosPendentes = [
  { id: '1', descricao: 'Contrato #F10293', valor: 1500, dataVencimento: new Date('2025-04-20'), cliente: 'Empresa ABC Ltda', status: 'pendente' },
  { id: '2', descricao: 'Consultoria Técnica', valor: 3200, dataVencimento: new Date('2025-04-15'), cliente: 'Construtora JKL', status: 'pendente' },
  { id: '3', descricao: 'Manutenção Mensal', valor: 800, dataVencimento: new Date('2025-04-10'), cliente: 'Condomínio Solar', status: 'atrasado' },
];

export const recebimentosRecentes = [
  { id: '4', descricao: 'Instalação de Painel', valor: 5000, dataPagamento: new Date('2025-04-01'), cliente: 'Residencial Verde', status: 'pago' },
  { id: '5', descricao: 'Projeto Técnico', valor: 1200, dataPagamento: new Date('2025-03-28'), cliente: 'Fazenda Energia', status: 'pago' },
];
